export type DeepPartial<T> = T extends object
    ? {
          [P in keyof T]?: DeepPartial<T[P]>
      }
    : T

export const untag = <T extends { type: string }>(obj: T): Omit<T, "type"> => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { type, ...rest } = obj
    return rest
}

export type Overwrite<T, U> = Omit<T, keyof U> & U

export type Prettify<T> = {
    [K in keyof T]: T[K] extends object ? Prettify<T[K]> : T[K]
} & unknown
